export default function FormSection({ title, description, children }) {
    return (
        <div className="form-section">
            <span className="form-section-title">{title}</span>
            {description && <p className="description">{description}</p>}
            <div className="form-fields">
                {children}
            </div>
        </div>
    );
}